export enum UserRole {
	COACHEE = 'COACHEE',
	COACH = 'COACH',
	MANAGER = 'MANAGER',
	ADMIN = 'ADMIN',
}
